import type { AxiosRequestConfig } from 'axios';
import axiosInstance from './axiosInstance';

export const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  return axiosInstance(config).then((response) => response.data as T);
};
